import { UPDATE_GLOBAL_TEST_STATUS } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_GLOBAL_TEST_STATUS:
            return action.payload
        default:
            return state
    }
}
